const ERROR_MESSAGE = {
  'too-many-files': 'ra.notification.file_count_exceed_error',
  'file-too-large': 'ra.notification.file_size_exceed_error',
  'file-invalid-type': 'ra.notification.file_invalid_type_error',
}

export const translateErrMessageDropZone = (errorCode): string => ERROR_MESSAGE[errorCode]
